"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var meta_knowledge_provider_service_1 = require("../api/meta-knowledge-provider.service");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var core_1 = require("@angular/core");
var HttpPartyProviderService = /** @class */ (function () {
    function HttpPartyProviderService(deService, metaKnowledgeProviderService) {
        this.deService = deService;
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
    }
    HttpPartyProviderService.prototype.getParties = function (category, entityId, entityData) {
        var _this = this;
        return this.loadEntityAndDefinitions(category, entityId, entityData).map(function (_a) {
            var entity = _a[0], partyDefinitions = _a[1];
            return _this.getSubEntity(entity, partyDefinitions.parties.field);
        });
    };
    HttpPartyProviderService.prototype.getParticipants = function (category, entityId, entityData) {
        var _this = this;
        return this.loadEntityAndDefinitions(category, entityId, entityData).map(function (_a) {
            var entity = _a[0], partyDefinitions = _a[1];
            return _this.getSubEntity(entity, partyDefinitions.participants.field);
        });
    };
    HttpPartyProviderService.prototype.getAdvocates = function (category, entityId, entityData) {
        var _this = this;
        return this.loadEntityAndDefinitions(category, entityId, entityData).map(function (_a) {
            var entity = _a[0], partyDefinitions = _a[1];
            return _this.getSubEntity(entity, partyDefinitions.advocates.field);
        });
    };
    HttpPartyProviderService.prototype.loadEntityAndDefinitions = function (category, entityId, entityData) {
        var partyDefinitions$ = this.metaKnowledgeProviderService.getPartyDefinitions(category);
        var mainEntity$ = entityData ? of_1.of(entityData) : this.deService.loadEntityByInstanceId(category, entityId);
        return zip_1.zip(mainEntity$, partyDefinitions$);
    };
    HttpPartyProviderService.prototype.getSubEntity = function (entity, metaFieldId) {
        return entity.getProperty(metaFieldId).value;
    };
    HttpPartyProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.DeService, meta_knowledge_provider_service_1.MetaKnowledgeProviderService])
    ], HttpPartyProviderService);
    return HttpPartyProviderService;
}());
exports.HttpPartyProviderService = HttpPartyProviderService;
//# sourceMappingURL=http-party-provider.service.js.map